import * as types from './constants';

// Retry Sendbird Batch Message
export const retrySendbirdBatchMessageRequest = data => (
  { type: types.RETRY_SENDBIRD_BATCH_MESSAGE_REQUEST, payload: data }
);

export const retrySendbirdBatchMessageDone = data => (
  { type: types.RETRY_SENDBIRD_BATCH_MESSAGE_DONE, payload: data }
);

export const retrySendbirdBatchMessageFailed = errors => (
  { type: types.RETRY_SENDBIRD_BATCH_MESSAGE_FAILED, payload: errors }
);

export const retrySendbirdBatchMessageReset = () => (
  { type: types.RETRY_SENDBIRD_BATCH_MESSAGE_RESET }
);